module.exports = __webpack_public_path__ + "img/hud-05.5483aae7.png";